import { render } from "./eye.svg?vue&type=template&id=0edc394f"
const script = {}
script.render = render

export default script